/* NgRx */
import { createAction, props } from '@ngrx/store';
import { GroupsList } from "../../../../models/groups-list";
import { Filter } from "../../../../models/filter";


/******** CLEAR STATE ***********/
const CLEAR_STATE = '[coach groups list] clear state';
export const ClearState = createAction(CLEAR_STATE);

/******** FETCH GROUPS LIST ***********/
const FETCH_GROUPS_LIST_REQUEST = '[coach groups list] fetch groups list request';
export const FetchGroupsListRequest = createAction(FETCH_GROUPS_LIST_REQUEST, props<any>());

const FETCH_GROUPS_LIST_SUCCESS = '[coach groups list] fetch groups list success';
export const FetchGroupsListSuccess = createAction(FETCH_GROUPS_LIST_SUCCESS, props<{
  groupsList: GroupsList,
  message: string
}>());

const FETCH_GROUPS_LIST_FAILURE = '[coach groups list] fetch groups list failure';
export const FetchGroupsListFailure = createAction(FETCH_GROUPS_LIST_FAILURE);

/******** FETCH GROUPS TYPE FILTER ***********/
const FETCH_GROUPS_TYPE_FILTER_REQUEST = '[coach groups list] fetch groups type request';
export const FetchGroupsTypeFilterRequest = createAction(FETCH_GROUPS_TYPE_FILTER_REQUEST);

const FETCH_GROUPS_TYPE_FILTER_SUCCESS = '[coach groups list] fetch groups type success';
export const FetchGroupsTypeFilterSuccess = createAction(FETCH_GROUPS_TYPE_FILTER_SUCCESS, props<{
  groupsTypeFilter: Filter,
  message: string
}>());

const FETCH_GROUPS_TYPE_FILTER_FAILURE = '[coach groups list] fetch groups type failure';
export const FetchGroupsTypeFilterFailure = createAction(FETCH_GROUPS_TYPE_FILTER_FAILURE);

/******** FETCH GROUPS STATUS FILTER ***********/
const FETCH_GROUPS_STATUS_FILTER_REQUEST = '[coach groups list] fetch groups status request';
export const FetchGroupsStatusFilterRequest = createAction(FETCH_GROUPS_STATUS_FILTER_REQUEST);

const FETCH_GROUPS_STATUS_FILTER_SUCCESS = '[coach groups list] fetch groups status success';
export const FetchGroupsStatusFilterSuccess = createAction(FETCH_GROUPS_STATUS_FILTER_SUCCESS, props<{
  groupsStatusFilter: Filter,
  message: string
}>());

const FETCH_GROUPS_STATUS_FILTER_FAILURE = '[coach groups list] fetch groups status failure';
export const FetchGroupsStatusFilterFailure = createAction(FETCH_GROUPS_STATUS_FILTER_FAILURE);

/******** GENERATE ATTENDANCE REPORT ***********/
const GENERATE_ATTENDANCE_REPORT_REQUEST = '[coach groups list] generate attendance report request';
export const GenerateAttendanceReportRequest = createAction(GENERATE_ATTENDANCE_REPORT_REQUEST, props<{ payload: any }>());

const GENERATE_ATTENDANCE_REPORT_SUCCESS = '[coach groups list] generate attendance report success';
export const GenerateAttendanceReportSuccess = createAction(GENERATE_ATTENDANCE_REPORT_SUCCESS);

const GENERATE_ATTENDANCE_REPORT_FAILURE = '[coach groups list] generate attendance report failure';
export const GenerateAttendanceReportFailure = createAction(GENERATE_ATTENDANCE_REPORT_FAILURE);

/*********** CLEAR PARTICIPANT FILTER **************/
const CLEAR_PARTICIPANT_FILTER_REQUEST = '[coach groups list] clear participant filter requested';
export const ClearParticipantFilterRequest = createAction(CLEAR_PARTICIPANT_FILTER_REQUEST);

/*********** FETCH PARTICIPANT FILTER **************/
const FETCH_PARTICIPANT_FILTER_REQUEST = '[coach groups list] fetch participant filter requested';
export const FetchParticipantFilterRequest = createAction(FETCH_PARTICIPANT_FILTER_REQUEST, props<any>());

const FETCH_PARTICIPANT_FILTER_SUCCESS = '[coach groups list] fetch participant filter successful';
export const FetchParticipantFilterSuccess = createAction(FETCH_PARTICIPANT_FILTER_SUCCESS, props<any>());

const FETCH_PARTICIPANT_FILTER_FAILURE = '[coach groups list] fetch participant filter failure';
export const FetchParticipantFilterFailure = createAction(FETCH_PARTICIPANT_FILTER_FAILURE);

/*********** FETCH GROUP FILTER **************/
const FETCH_GROUP_FILTER_REQUEST = '[coach groups list] fetch group filter requested';
export const FetchGroupFilterRequest = createAction(FETCH_GROUP_FILTER_REQUEST, props<any>());

const FETCH_GROUP_FILTER_SUCCESS = '[coach groups list] fetch group filter successful';
export const FetchGroupFilterSuccess = createAction(FETCH_GROUP_FILTER_SUCCESS, props<any>());

const FETCH_GROUP_FILTER_FAILURE = '[coach groups list] fetch group filter failure';
export const FetchGroupFilterFailure = createAction(FETCH_GROUP_FILTER_FAILURE);
